import { Stack, Tab, Tabs, Box } from '@mui/material';
import Acessos from './Acessos';
import PoliticasAcesso from './PoliticasAcesso';
import { useState } from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}


function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;



  return (
    <div
      style={{ width: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function AbasAcessos() {
  const [value, setValue] = useState<number>(0);
  function handleChange(event: React.SyntheticEvent, newValue: number) {
    setValue(newValue);
  };

  return (
    <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' width='100%' spacing={2}>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor='secondary'
        textColor='secondary'
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label='Acessos adm' value={0} />
        <Tab label='Políticas de autenticação' value={1} />
      </Tabs>
      <CustomTabPanel value={value} index={0}>
        <Acessos />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <PoliticasAcesso />
      </CustomTabPanel>
    </Stack>
  )
}
